import { ArchiveIcon } from 'svg/ArchiveIcon';
import { CalendarIcon } from 'svg/CalendarIcon';
import { EventsIcon } from 'svg/EventsIcon';
import { GuestsIcon } from 'svg/GuestsIcon';
import { LocationIcon } from 'svg/LocationIcon';
import { navigationUrls } from 'navigation/routes';
import { StaffIcon } from 'svg/StaffIcon';
import { TagIcon } from 'svg/TagIcon';
import { TemplatesIcon } from 'svg/TemplatesIcon';
import { TicketsIcon } from 'svg/TicketsIcon';

import { ISidebarItem } from 'types/models/Sidebar';

// Элементы меню в сайдбаре
export const ADMIN_MAIN_MENU_ITEMS: ISidebarItem[] = [
  {
    label: 'menu.events',
    url: navigationUrls.events.index,
    id: 'events',
    Icon: EventsIcon
  },
  {
    label: 'menu.users',
    url: navigationUrls.users.index,
    id: 'users',
    Icon: StaffIcon
  },
  {
    label: 'menu.hallTemplates',
    url: navigationUrls.hallTemplates.index,
    id: 'hallTemplates',
    Icon: TemplatesIcon
  },
  {
    label: 'menu.locations',
    url: navigationUrls.locations.index,
    id: 'locations',
    Icon: LocationIcon
  },
  {
    label: 'menu.tickets',
    url: navigationUrls.tickets.index,
    id: 'tickets',
    Icon: TicketsIcon
  },
  {
    label: 'menu.guests',
    url: navigationUrls.guests.index,
    id: 'guests',
    Icon: GuestsIcon
  },
  {
    label: 'menu.tags',
    url: navigationUrls.tags.index,
    id: 'tags',
    Icon: TagIcon
  },
  {
    label: 'menu.archive',
    url: navigationUrls.archive.index,
    id: 'archive',
    Icon: ArchiveIcon
  },
  {
    label: 'menu.calendar',
    url: navigationUrls.calendar.index,
    id: 'calendar',
    Icon: CalendarIcon
  }
  /** TODO: Раздел скрыт на время MVP */
  // {
  //   label: 'menu.personalAccount',
  //   url: '',
  //   id: 'personalAccount',
  //   Icon: UserIcon
  // }
];

// Элементы меню в сайдбаре
export const MANAGER_EVENT_MAIN_MENU_ITEMS: ISidebarItem[] = [
  {
    label: 'menu.events',
    url: navigationUrls.events.index,
    id: 'events',
    Icon: EventsIcon
  },
  {
    label: 'menu.hallTemplates',
    url: navigationUrls.hallTemplates.index,
    id: 'hallTemplates',
    Icon: TemplatesIcon
  },
  {
    label: 'menu.locations',
    url: navigationUrls.locations.index,
    id: 'locations',
    Icon: LocationIcon
  },
  {
    label: 'menu.tickets',
    url: navigationUrls.tickets.index,
    id: 'tickets',
    Icon: TicketsIcon
  },
  {
    label: 'menu.archive',
    url: navigationUrls.archive.index,
    id: 'archive',
    Icon: ArchiveIcon
  },
  {
    label: 'menu.calendar',
    url: navigationUrls.calendar.index,
    id: 'calendar',
    Icon: CalendarIcon
  }
];

// Элементы меню в сайдбаре для координатора мероприятий
export const COORDINATOR_EVENT_MAIN_MENU_ITEMS: ISidebarItem[] = [
  {
    label: 'menu.events',
    url: navigationUrls.events.index,
    id: 'events',
    Icon: EventsIcon
  },
  {
    label: 'menu.tickets',
    url: navigationUrls.tickets.index,
    id: 'tickets',
    Icon: TicketsIcon
  },
  {
    label: 'menu.archive',
    url: navigationUrls.archive.index,
    id: 'archive',
    Icon: ArchiveIcon
  },
  {
    label: 'menu.calendar',
    url: navigationUrls.calendar.index,
    id: 'calendar',
    Icon: CalendarIcon
  }
];

// Элементы меню в сайдбаре
export const MANAGER_SEAT_MAIN_MENU_ITEMS = COORDINATOR_EVENT_MAIN_MENU_ITEMS;
